(function () {
  'use strict';

  var root = document.querySelector('[data-cc-custom-dropdown]');
  if (!root) return;

  var form = document.querySelector('[data-cc-product-form]');
  var pills = root.querySelectorAll('[data-cc-dropdown-option]');
  var label = root.dataset.label || 'Option';
  var property = root.dataset.property || label;
  var required = root.hasAttribute('data-required');
  var input = null;

  function dispatch(filled) {
    document.dispatchEvent(new CustomEvent('cc:dropdown-changed', {
      detail: { property: property, label: label, filled: filled, min: 1, required: required }
    }));
  }

  function select(value) {
    var matched = 0;

    pills.forEach(function (pill) {
      var isSelected = pill.dataset.ccDropdownOption === value;
      pill.classList.toggle('is-selected', isSelected);
      pill.setAttribute('aria-checked', isSelected ? 'true' : 'false');
      if (isSelected) matched = 1;
    });

    // properties[<property>] = selected value via a JS-managed hidden input;
    // removed entirely if nothing valid is selected (keeps a required gate open).
    if (matched) {
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + property + ']';
        form.appendChild(input);
      }
      input.value = value;
    } else if (input) {
      input.remove();
      input = null;
    }

    dispatch(matched);
  }

  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      select(this.dataset.ccDropdownOption);
    });
  });

  // Fire once on init, respecting a pre-selected default (rendered is-selected
  // by Liquid). No default → dispatch filled:0 so a required gate starts unmet.
  var preselected = root.querySelector('[data-cc-dropdown-option].is-selected');
  if (preselected) {
    select(preselected.dataset.ccDropdownOption);
  } else {
    dispatch(0);
  }
})();
